import { useState } from "react";
import { useContent } from "@/context/ContentContext";
import { toast } from "sonner";

// Clave pública de Web3Forms (los envíos llegan al correo con el que se dio de alta).
// Sin clave, el formulario abre el cliente de correo del visitante.
const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_KEY;
const EMPTY = { name: "", email: "", project_type: "", message: "", botcheck: "" };

export const Contacto = () => {
  const { contacto: c } = useContent();
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle"); // idle | sending | sent
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const to = c?.email || "hola@somostaandem.com";
  const subject = `Contacto web — ${form.name}${form.project_type ? " · " + form.project_type : ""}`;

  const openMail = () => {
    const body = `Nombre: ${form.name}\nEmail: ${form.email}\nTipo de proyecto: ${form.project_type || "-"}\n\n${form.message}`;
    window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Completa nombre, email y mensaje.");
      return;
    }
    if (!WEB3FORMS_KEY) {
      openMail();
      toast.success("Abriendo tu correo…");
      return;
    }
    setStatus("sending");
    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: WEB3FORMS_KEY,
          subject,
          from_name: "Web TAANDEM",
          replyto: form.email,
          Nombre: form.name,
          Email: form.email,
          "Tipo de proyecto": form.project_type || "-",
          Mensaje: form.message,
          botcheck: form.botcheck,
        }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.message);
      setStatus("sent");
      setForm(EMPTY);
    } catch {
      setStatus("idle");
      toast.error(`No se ha podido enviar. Escríbenos a ${to}.`);
    }
  };

  return (
    <section className="sec or on-bn" id="contacto" data-testid="contacto">
      <div className="wrap split">
        <div style={{ display: "flex", flexDirection: "column" }}>
          <p className="lb">{c?.label}</p>
          <h2 className="h h2" style={{ marginTop: 20 }}>
            {c?.title} <span className="ac">{c?.title_accent}</span>
          </h2>
          <p className="lead" style={{ marginTop: 24 }}>{c?.description}</p>
          <a
            href={`mailto:${c?.email}`}
            className="h h3"
            style={{ marginTop: "auto", paddingTop: 40, color: "var(--k)" }}
            data-testid="contacto-email-link"
          >
            {c?.email}
          </a>
        </div>

        {status === "sent" ? (
          <div className="form" role="status" data-testid="contact-form-sent">
            <h3 className="h h3">Mensaje enviado.</h3>
            <p className="lead">Gracias. Te respondemos en menos de 24 horas desde {to}.</p>
            <div>
              <button className="btn ink" type="button" onClick={() => setStatus("idle")}>Enviar otro mensaje</button>
            </div>
          </div>
        ) : (
        <form className="form" onSubmit={submit} data-testid="contact-form">
          <input
            type="checkbox"
            name="botcheck"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            checked={!!form.botcheck}
            onChange={(e) => setForm((f) => ({ ...f, botcheck: e.target.checked ? "1" : "" }))}
            style={{ display: "none" }}
          />
          <div className="fld">
            <label htmlFor="c-name">Nombre</label>
            <input id="c-name" type="text" value={form.name} onChange={set("name")} data-testid="contact-form-name-input" />
          </div>
          <div className="fld">
            <label htmlFor="c-email">Email</label>
            <input id="c-email" type="email" value={form.email} onChange={set("email")} data-testid="contact-form-email-input" />
          </div>
          <div className="fld">
            <label htmlFor="c-type">Tipo de proyecto</label>
            <select id="c-type" value={form.project_type} onChange={set("project_type")} data-testid="contact-form-project-type">
              <option value="">Selecciona una opción</option>
              {(c?.project_types || []).map((t, i) => <option key={i} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="fld">
            <label htmlFor="c-msg">Mensaje</label>
            <textarea id="c-msg" value={form.message} onChange={set("message")} data-testid="contact-form-message-input" />
          </div>
          <div>
            <button className="btn ink" type="submit" disabled={status === "sending"} data-testid="contact-form-submit-button">
              {status === "sending" ? "Enviando…" : "Enviar mensaje"}
            </button>
          </div>
        </form>
        )}
      </div>
    </section>
  );
};
